export default class Player extends Phaser.Sprite {

  constructor(game, x = 0, y = 0) {
    super(game, x, y, 'player');

    this.stats = {
      jump: 300,
      speed: 200,
      gravity: 600
    };
    this.DEFAULT_STATS = {
      ball: {
        jump: 300,
        speed: 400,
        gravity: 400
      },
      cone: {
        jump: 400,
        speed: 200,
        gravity: 400
      },
      cube:{
        jump: 300,
        speed: 200,
        gravity: 600
      }
    };

    this.BALL_SPEED_BOOST = 600;
    this.BALL_ANGLE_SPEED = 20;
    this.CONE_DASH_BOOST = 400;
    this.CONE_DASH_ANGLE = 90;
    this.CONE_DASH_DURATION = 400;
    this.CONE_DASH_DELAY = 300;
    this.CUBE_STOMP_SPEED = 10;
    this.CONE_ANGLE_SKEW = 10;
    this.CUBE_ANGLE_SPEED = 10;

    this.nextDashAt = 0;

    this.form = 'cube';
    this.cube();

    this.statsDelay = 0;
    this.onBlock = false;

    this.animations.add('ball', [0]);
    this.animations.add('cone', [1]);
    this.animations.add('cube', [2]);
  }

  update() {
  }

  changeForm(form) {
    this.angle = 0;
    this.form = form;
    this.animations.play(form);
  }

  ball() {
    this.changeForm('ball');
    this.stats.speed = this.DEFAULT_STATS.ball.speed;
    setTimeout(() => {
      this.stats.jump = this.DEFAULT_STATS.ball.jump;
      this.stats.speed = this.DEFAULT_STATS.ball.speed;
      this.stats.gravity = this.DEFAULT_STATS.ball.gravity;
    }, this.statsDelay);
  }
  cone() {
    this.changeForm('cone');
    this.stats.jump = this.DEFAULT_STATS.cone.jump;
    setTimeout(() => {
      this.stats.jump = this.DEFAULT_STATS.cone.jump;
      this.stats.speed = this.DEFAULT_STATS.cone.speed;
      this.stats.gravity = this.DEFAULT_STATS.cone.gravity;
    }, this.statsDelay);
  }
  cube() {
    this.changeForm('cube');
    this.stats.gravity = this.DEFAULT_STATS.cube.gravity;
    setTimeout(() => {
      this.stats.jump = this.DEFAULT_STATS.cube.jump;
      this.stats.speed = this.DEFAULT_STATS.cube.speed;
      this.stats.gravity = this.DEFAULT_STATS.cube.gravity;
    }, this.statsDelay);
  }

  moveEffect(direction) {


    if (this.form === 'ball') {
      switch (direction) {
      case 'left':
        this.angle -= this.BALL_ANGLE_SPEED;
        break;
      case 'right':
        this.angle += this.BALL_ANGLE_SPEED;
        break;
      }
    }

    if (this.form === 'cone') {
      switch (direction) {
      case 'left':
        this.angle = -this.CONE_ANGLE_SKEW;
        break;
      case 'right':
        this.angle = this.CONE_ANGLE_SKEW;
        break;
      }
    }

    if (this.form === 'cube') {
      switch (direction) {
      case 'left':
        this.angle -= this.CUBE_ANGLE_SPEED;
        break;
      case 'right':
        this.angle += this.CUBE_ANGLE_SPEED;
        break;
      }
    }
  }
}